import { Flex } from '@/components';
import type { FC } from 'react';
import { WorkflowListSearchAccordion } from './search';
import { WorkflowListTable } from './table';

export const WorkflowListContent: FC = () => {
  return (
    <Flex vertical gap="middle">
      <WorkflowListSearchAccordion />
      <WorkflowListTable />
    </Flex>
  );
};
